<template>
	<!-- A guest cart line with no catalogue row behind it - its price could not be loaded,
	     or the product is no longer available. Priced lines are regular SubscriptionCards;
	     this shows the product code, the quantity and a remove control only. -->
	<div class="subscription-card">
		<div class="subscription-card-header">
			<h6 class="subscription-card-title">{{ product_id }}</h6>
			<span class="subscription-card-qty-chip">{{ qty }}</span>
			<div class="del grey-btn" @click="emit('remove')">
				<!-- Same markup as SubscriptionCard's remove glyph minus id="icon-close". That card
				     gets its fill from Frappe's #icon-close rule by reusing the sprite symbol's id;
				     here the same token is set directly, since .icon alone leaves the glyph
				     transparent and a second element with that id is not valid HTML. -->
				<svg class="icon sm remove-cart-item-logo" width="18" height="18"
					style="fill: var(--invert-neutral)"
					viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
					<path fill-rule="evenodd" clip-rule="evenodd"
						d="M4.146 11.217a.5.5 0 1 0 .708.708l3.182-3.182 3.181 3.182a.5.5 0 1 0 .708-.708l-3.182-3.18 3.182-3.182a.5.5 0 0 0-.708-.708l-3.18 3.181-3.183-3.182a.5.5 0 0 0-.708.708l3.182 3.182-3.182 3.181z"
						stroke-width="0"></path>
				</svg>
			</div>
		</div>
		<div v-if="note" class="small text-muted">{{ note }}</div>
	</div>
</template>

<script setup>
defineProps({
	product_id: {
		type: String,
		required: true
	},
	qty: {
		type: Number,
		required: true
	},
	note: {
		type: String,
		default: ""
	}
})

const emit = defineEmits(['remove'])
</script>
